/* eslint-disable react/prop-types */
import Image from "next/image";
import Link from "next/link";

function CategoryItem({category, sectionContainer, categoryBackgroundColor}) {
  let classes = "my-2 md:my-5 relative";
  const style = {
    backgroundColor: categoryBackgroundColor,
  };

  if (sectionContainer === "stamp") {
    classes = classes + " stamp-border";
    style.backgroundImage = `radial-gradient(8px, transparent 98%, ${categoryBackgroundColor}),linear-gradient(${categoryBackgroundColor} 0px, ${categoryBackgroundColor} 0px)`;
    style.backgroundColor = '';
    style.color = categoryBackgroundColor;
    style.padding = '34px 35px 30px 35px';
  }

  return (
    <div className={classes} style={style}>
      <Link href={`product-category/${category.category.slug}`} className="rounded-2xl overflow-hidden block">
        <Image src={category.image.url} alt={category.image.alt} width={category.image.width} height={category.image.height} />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center z-1 text-3xl md:text-4xl lg:text-5xl 2xl:text-6xl font-bold font-special text-center w-full px-12">
          {category.category.name}
        </div>
      </Link>
    </div>
  )
}

export default CategoryItem